import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Location } from '@angular/common';

import { ReasonValidator } from '../../reason.validator';
import { AuxFunction } from '../../../../_helpers/aux.function';
import { FormValidator } from '../../../../_helpers/form.validator';
import { Translation } from '../../../../_languages/translations';
import {Reason} from '../../../../_models/reason';

@Component({
  selector: 'app-reason-edit',
  templateUrl: './reason-edit.component.html'
})
export class ReasonEditComponent implements OnInit {

  // Para el control del diccionario de traducción.
  tr: {};
  auxFunction: AuxFunction;

  title: string;
  subtitle: string;

  reasonForm: FormGroup;

  actionModal: boolean;
  alertModal: boolean;
  infoModal: boolean;

  actionInfo: string;
  alertInfo = '';
  infoInfo: string;

  // Variable para el control de las validaciones del formulario y sus mensajes.
  formValidator: FormValidator;


  @Input() reason: Reason;
  @Input() reasonTypes: Reason[];
  @Output() updateReason = new EventEmitter<Reason>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private _location: Location,
    public trans: Translation
  ) {
    this.formValidator = new FormValidator();
  }

  // convenience getter for easy access to form fields
  get f() { return this.reasonForm.controls; }

  ngOnInit() {

    this.tr = this.trans.vocabulary;
    this.auxFunction = new AuxFunction();

    // Los procesos siempre van a tener género 1 y tipo 3.
    this.reasonForm = this.formBuilder.group({
      id:  this.reason.id,
      name: [this.reason.name, Validators.required],
      type_id: [this.reason.type_id, Validators.required],
      description: this.reason.description,
      text: this.reason.text,
      order: this.reason.order,
      active: this.reason.active,
    });

    // Asignamos los mensajes de error asociados a las validaciones que vamos a usar en el formulario.
    this.formValidator.setTemplateMessages(ReasonValidator.templateMessages);

    this.title = this.tr['reasonTitle'];
    this.subtitle = this.tr['reasonEditSubtitle'];

    this.actionInfo = this.tr['modalReasonEditInfo'];

    this.infoInfo = this.tr['modalOkInfo'];


    // Se crean las subscripciones para el control de los campos del formulario.
    this.formValidator.subscribeFormGroup(this.reasonForm);

  } // End function OnInit

  saveReason(): void {

    // NOTA: Se copian los cambios sobre la obra inicial.
    const p = { ...this.reason, ...this.reasonForm.value };

    this.updateReason.emit(p);

  } // End function saveReason

  changeUser(event: any): void {

    console.log('---> Cambiando Usuario:');
    console.log(event);

  } // End function changeUser

  // ------------------------------------
  //    VALIDACIÓN FINAL DEL FORMULARIO
  // ------------------------------------

  validateReason(): void {

    // Se realizan las comprobaciones pertinentes para confirmar que los campos del formulario son correctos.

    if (this.reasonForm.valid) {
      console.log('-------> Formulario reasonForm correcto.');

      if (this.reasonForm.controls.name.value === '' && this.reasonForm.controls.name.value === undefined) {
        this.alertInfo += this.tr['alertReasonName'];
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      } else {
        this.showActionModal(true);
      }

    } else {
      console.log('-------> Formulario reasonForm NO válido:');
      console.log(this.reasonForm);

      this.alertInfo += this.tr['alertReasonForm'];
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      this.alertInfo = '';
    }
  } // End function validateReason

  // ------- Función de regreso
  back(): void {
    // this._location.back();
    this.router.navigate(['/reason']);
  } // End function back

  // -----------------------------------------------
  //  FUNCIONES PARA EL CONTROL DE VENTANAS MODALES
  // -----------------------------------------------

  showActionModal(value: boolean) {
    this.actionModal = value;

  } // End function showActionModal

  confirmActionModal() {

    console.log('--> - -> Confirmada acción del modal.');

    this.saveReason();

    this.showActionModal(false);
  } // End function confirmActionModal

} // End Class ReasonEditComponent
